export const SUB_ACCOUNT_BYTE_LENGTH = 32;
export const CREATE_CANISTER_MEMO = BigInt(0x41455243); // CREA,
export const TOP_UP_CANISTER_MEMO = BigInt(0x50555054); // TPUP

export const TRANSACTION_FEE = BigInt(10_000);

// Note:  Canister IDs are not constant, so are not provided here.
//        The same applies to HOST.
export const E8S_PER_TOKEN = BigInt(100000000);
